import { Browse } from 'spa/components/browse'
import { Layout, Sidebar } from 'spa/components/layout'
import { ModuleLoader } from 'spa/components/module_loader/module_loader'
import React from 'react'
const Exclusives = React.lazy(() => import('./exclusives'))

const display = () => {
  return (
    <Layout tabTitle="exclusives">
      <Sidebar>
        <Browse />
      </Sidebar>
      <ModuleLoader>
        <Exclusives />
      </ModuleLoader>
    </Layout>
  )
}

export { display as ExclusivesDisplay }

export { Exclusives }

export default Exclusives
